import { DiscoveryContentTypes } from '../../../../constants';
import { FacetType } from '../../../../types';

export const MAIN_MENU_HEIGHT = 55;

type ContentDataMapType = {
  [key in DiscoveryContentTypes]: {
    heading: string;
    buttonText: string;
  };
};

export const CONTENT_TYPES_DATA_MAP = {
  [DiscoveryContentTypes.ALL]: {
    heading: 'All Content Types',
  },
  [DiscoveryContentTypes.MODULE]: {
    heading: 'Content',
    buttonText: 'View Full Content',
  },
  [DiscoveryContentTypes.SPONSOR]: {
    heading: 'Sponsors',
    buttonText: 'View All Sponsors',
  },
  [DiscoveryContentTypes.SPEAKER]: {
    heading: 'Speakers',
    buttonText: 'View All Speakers',
  },
} as ContentDataMapType;

export const HEADING_MAP = {
  [FacetType.CONTENT_TYPE]: 'Content Types',
  [FacetType.SEARCH_MODULE_PAGE_NAMES]: 'Page Names',
  [FacetType.SPONSOR_CATEGORIES]: 'Categories',
  [FacetType.SPEAKER_STREAMS]: 'Streams',
};

export const MAX_FILTER_TO_SHOW_COUNT_MAP = {
  [FacetType.CONTENT_TYPE]: 5,
  [FacetType.SEARCH_MODULE_PAGE_NAMES]: 5,
  [FacetType.SPONSOR_CATEGORIES]: 5,
  [FacetType.SPEAKER_STREAMS]: 5,
};

export const FACET_TYPE_ORDER = [
  FacetType.SEARCH_MODULE_PAGE_NAMES,
  FacetType.SPONSOR_CATEGORIES,
  FacetType.SPEAKER_STREAMS,
];

export const ZERO_COUNT_FACETS_HIDDEN_LIST = [FacetType.CONTENT_TYPE];
